import { Row, Col } from "reactstrap";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { default as useContractStore } from "./utils/useContractStore";
import { default as common } from "./utils/common";
import { ui_helpers } from "../../helpers";
const { PHASE_NAMES } = common;

export default function ContractCrumbs({
  phaseList,
  currentPhase,
  isCompanyAdmin,
  isSystemAdmin,
  currentUserHasContractCreatorRole,
  onSetPhase,
}) {
  const getWarnings = useContractStore((x) => x.getWarnings);
  const wasInitialCreation = useContractStore((x) => x.wasInitialCreation);
  const inventoryId = useContractStore((x) => x.inventoryId);
  const isQuote = useContractStore((x) => x.isQuote);

  let phaseLinks = [];
  for (let i = 0; i < phaseList.length; i++) {
    const phaseValid = getWarnings(phaseList[i]).warnings.length === 0;
    let linkEnabled =
      (isCompanyAdmin || isSystemAdmin) &&
      (i === 0 || !wasInitialCreation || !currentUserHasContractCreatorRole || phaseValid);
    // special logic to disable link for Build to force click of the Next button to create inventory
    if (linkEnabled && phaseList[i] === PHASE_NAMES.BUILD && !inventoryId) {
      linkEnabled = false;
    }
    let linkSpan = null;
    if (i === currentPhase) {
      linkSpan = (
        <div className="text-center" style={{ width: "90%", fontSize: "0.85rem" }}>
          {phaseList[i]} {phaseValid ? ui_helpers.greenCheck() : ui_helpers.redExclamation()}
        </div>
      );
    } else if (!linkEnabled) {
      linkSpan = (
        <div
          className="text-center"
          style={{
            width: "90%",
            color: "#999",
            paddingTop: "8px",
            fontSize: "0.85rem",
          }}>
          {phaseList[i]} {phaseValid ? ui_helpers.greenCheck() : null}
        </div>
      );
    } else {
      linkSpan = (
        <div
          className="btn btn-link text-center"
          style={{ width: "90%", fontSize: "0.85rem" }}
          onClick={() => onSetPhase(i)}>
          {phaseList[i]} {phaseValid ? ui_helpers.greenCheck() : null}
        </div>
      );
    }
    phaseLinks.push(
      <Col key={i} className={classnames({ "current-phase": i === currentPhase })}>
        {i > 1 ? (
          <FontAwesomeIcon
            icon="angle-right"
            size="2x"
            style={{ marginTop: "3px", float: "left" }}
          />
        ) : null}
        {linkSpan}
      </Col>
    );
  }
  return <Row className={isQuote ? "breadcrumb-quote" : "breadcrumb"}>{phaseLinks}</Row>;
}
